var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLaney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 92,
    viewBox: "0 0 88 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 92,
    rx: 18,
    fill: "url(#paint0_linear_3294_2213)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.8453 42.087C72.688 30.1689 67.6671 21.6151 57.7857 16.8193C47.0318 11.594 34.907 14.2961 28.9247 19.5214C21.2154 26.232 19.7732 33.5511 21.4112 45.6481C21.8207 48.7618 21.0552 51.6966 18.064 51.3029C16.337 51.0703 15.3399 49.2808 14.3607 50.0681C13.8444 50.4797 13.969 51.6071 14.2005 52.9134C15.1797 58.2819 17.0492 64.6704 24.2778 70.9874C34.1058 79.5949 50.1654 80.3464 61.1151 72.8663C71.1924 65.9947 74.8779 52.7882 73.8274 42.0512L73.8453 42.087ZM49.9161 49.8713C47.0496 49.8713 44.735 45.7912 44.735 40.7628C44.735 35.7343 47.0496 31.6542 49.9161 31.6542C52.7826 31.6542 55.0972 35.7343 55.0972 40.7628C55.0972 45.7912 52.7826 49.8713 49.9161 49.8713ZM64.6048 49.8713C62.1299 49.8713 60.118 45.7912 60.118 40.7628C60.118 35.7343 62.1299 31.6542 64.6048 31.6542C67.0796 31.6542 69.0915 35.7343 69.0915 40.7628C69.0915 45.7912 67.0796 49.8713 64.6048 49.8713Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3294_2213",
    x1: 44,
    y1: 0,
    x2: 44,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EA575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27C840"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLaney);
export default __webpack_public_path__ + "static/media/ic-laney.019a188958d1bb1a2901e7b1b04fa05d.svg";
export { ForwardRef as ReactComponent };